<template lang="html">
  <h1 class="title">{{ $t('error.403') }}</h1>
</template>

<script>
module.exports = {}
</script>

